<!-- ApplicationListComponent.vue -->
<template>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-button class="button_back" data-testid="directions-32" @click="goBack()">
                <ion-icon name="arrow-back-outline"></ion-icon>
            </ion-button>
        </ion-buttons>
        <ion-title>My Jobs</ion-title>
  

    </ion-toolbar>
    <div class="main_wrapper ion-padding">
        <div class="container">
            <div v-if="initialIsLoading">
                <job-listing-skeleton :skeletonCount="7" />
            </div>
            <div v-else>
                <template v-if="applications.length > 0">
                <ApplicationCard :applications="applications"
                    :toggleDetails="toggleDetails" :handleAnchorClick="handleAnchorClick" @refresh-applicants-list="refreshApplicants"/>
            </template>
            <template v-else>
                <div class="search_jobs_wrapper search_empty">
                    <div class="search_jobs_header">
                        <img :src="require(`@/assets/img/illustrations/search0.svg`)" alt="" />
                        <div class="main_title">Job Applicants details</div>
                        <div class="main_text">
                            Please wait loading Job Applicants details.
                        </div>
                    </div>
                </div>
            </template>
            </div>
        </div>
      
    </div>
</template>
  
<script>
import { useStore } from "vuex";
import {
    useRoute, useRouter
} from "vue-router";
import { onMounted, ref, inject, computed, onBeforeMount, provide } from 'vue';
import ApplicationCard from './Cards/ApplicationCard.vue';
import JobListingSkeleton from "@/components/JobListingSkeleton/JobListingSkeleton.vue";
import {
    IonToolbar,
    IonButton,
    IonButtons,
} from "@ionic/vue";


export default {
    components: {
        ApplicationCard,
        IonToolbar,
        IonButton,
        IonButtons,
        JobListingSkeleton
    },
    setup() {
        const $store = useStore();
        const $router = useRouter();
        const setPageClassGlobal = inject('setPageClassGlobal');
        const $route = useRoute();
        const applicantStatusCategories = ref([]);
        const applications = ref([]);
        const isLoading = ref(false); // Track if data is currently being loaded
        const initialIsLoading = ref(false);
        const jobId = computed(() => $route.params.jobId);
        provide('applicantCategories', applicantStatusCategories);
       

        // Provide the refresh function to children
        const goBack = () => {

            $router.push({
                name: "job_poster",
            });

        };
        const goNext = () => {
            $router.push({
                name: 'create_job_listing',
            });
        };

        onBeforeMount(async () => {
      try {
        const applicantStatusCategoriesResponse = await $store.dispatch("GET_JOB_APPLICANT_STATUS_CATEGORIES");
        applicantStatusCategories.value = applicantStatusCategoriesResponse.data;
      } catch (error) {
        console.error("Error occurred:", error);
      }
    });
        onMounted(() => {
            setPageClassGlobal('global_job_seeker_page');
            initialFetchJobData();
        });


        const initialFetchJobData = async () => {
            return new Promise((resolve) => {
                initialIsLoading.value = true;
                $store.dispatch("JOB_POSTER_APPLICANTS_LIST", { filter: { job_post_id: jobId.value } })
                    .then((response) => {
                        let jobFetchResult = response.data;
                        console.log("🚀 ~ .then ~ jobFetchResult:232", jobFetchResult)
                        const jobsData = jobFetchResult.map(job => ({
                            id: job.id,
                            applicantName: job?.applicant?.name,
                            image: job?.applicant?.image,
                            role: job?.applicant?.seekerRole,
                            otherRole: job?.applicant?.categoryLevelOther,
                            address: job?.applicant?.address,
                            experience: job?.applicant?.experience,
                            hourlyRate: job?.applicant?.salaryExpectationHourly,
                            annuallyRate: job?.applicant?.salaryExpectationAnnually,
                            cv: job.cv,
                            // cv: {
                            //     link: true
                            // },
                            skills: job?.applicant?.skills,
                            aboutMe: job?.applicant?.aboutMe,
                            result: true,
                            title: job.jobPost.title,
                            poster: job.jobPost.pharmacy.name,
                            shortDescription: job.jobPost.shortDescription,
                            type: job.jobPost.type,
                            applied: job.appliedAgo,
                            jobPostId: job.jobPost.id,
                            application_tag_status: job.applicationTagStatus,
                            description: job.jobPost.description,
                            questions: job.questions,
                            payInterval: job.jobPost.payInterval,
                            federalPharmacistSupport:job.jobPost.federalPharmacistSupport,
                        }));
                        console.log("data are", jobsData);
                        // Assign the mapped data to the jobs ref variable
                        applications.value = jobsData;
                        applications.value.meta = response.meta;
                        initialIsLoading.value = false;
                        resolve(response);
                    });
            });
        };

        const refreshApplicants = () => {
            console.log("🚀 ~ refreshJobs ~ refreshJobs");
            initialFetchJobData();
        };
        const maximizedCardId = ref(null);

        const toggleDetails = (application, event) => {
            // Check if the click event originated from the anchor tag
            if (event.target.tagName.toLowerCase() === 'a') {
                return;
            }

            if (maximizedCardId.value === application.id) {
                // Clicking on the same maximized card, minimize it
                maximizedCardId.value = null;
                application.isDetailsVisible = false;
            } else {
                // Clicking on a different card, minimize the currently maximized card
                // and maximize the clicked card
                if (maximizedCardId.value !== null) {
                    const maximizedCard = applications.value.find(app => app.id === maximizedCardId.value);
                    if (maximizedCard) {
                        maximizedCard.isDetailsVisible = false;
                    }
                }
                maximizedCardId.value = application.id;
                application.isDetailsVisible = true;
            }
        };

        const handleAnchorClick = (event) => {
            console.log("🚀 ~ handleAnchorClick ~ event:", event)
            // Handle anchor tag click logic here
            console.log('Anchor tag clicked');
        };
        provide('refreshApplicants', refreshApplicants);

        return {
            applications,
            toggleDetails,
            handleAnchorClick,
            isLoading,
            jobId,
            goBack,
            goNext,
            refreshApplicants,
            applicantStatusCategories,
            initialIsLoading
        };
        
    }
};
</script>